<template>
  <div class="page-view">
    <q-btn
      @click="$emit('changeView', 'list')"
      :class="{ active: pageView === 'list' }"
      icon="mdi-view-list"
      text-color="blue-grey-6"
      flat
      size="sm"
      class="btn--no-hover list"
      :ripple="false"
      label="List"
    >
    </q-btn>
    <q-btn
      @click="$emit('changeView', 'grid')"
      :class="{ active: pageView === 'grid' }"
      icon="mdi-view-module"
      text-color="blue-grey-6"
      flat
      size="sm"
      class="btn--no-hover grid"
      :ripple="false"
      label="Tiles"
    >
      <q-tooltip>Grid view</q-tooltip>
    </q-btn>
  </div>
</template>

<script>
export default {
  name: 'PageView',
  props: {
    pageView: {
      type: String,
      default: 'grid',
    },
  },
};
</script>

<style scoped lang="scss">
.page-view {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;

  .q-btn {
    border: 1px solid #ced4e6;
    min-width: 80px;
    border-radius: 0;
    &.active {
      background-color: #ced4e6;
    }

    &.list {
      border-bottom-left-radius: 8px;
      border-top-left-radius: 8px;
    }

    &.grid {
      border-bottom-right-radius: 8px;
      border-top-right-radius: 8px;
    }
  }
}
</style>
